import client from "Libs/platform";
import { apiProxyRequest } from "Api/apiProxyRequest";

const isSameOrigin = (href: string, apiUrl: string): boolean => {
  try {
    // Resolve relative hrefs against the api_url so a relative HAL link
    // (e.g. /billing/.../pdf) compares same-origin and still routes through
    // apiProxyRequest (which prepends api_url); only genuinely cross-origin
    // absolute links take the tokenless path.
    return new URL(href, apiUrl).origin === new URL(apiUrl).origin;
  } catch {
    return false;
  }
};

// The pdf endpoint streams the raw PDF bytes (Content-Type application/pdf).
// apiProxyRequest returns the raw Response for binary content types, so read it
// as a Blob.
//
// `apiProxyRequest`/the client attach the OAuth bearer token to any URL, so we
// only route the pdf link through it when it's same-origin as the API. If the
// link ever resolves to a different host (e.g. a pre-signed storage URL), fetch
// it without our token so the access token isn't leaked to a third party.
export const getInvoicePdfRequest = async (pdfHref: string): Promise<Blob> => {
  const apiUrl = client.getConfig().api_url;

  if (isSameOrigin(pdfHref, apiUrl)) {
    const response = await apiProxyRequest<Response>(pdfHref);
    return response.blob();
  }

  const response = await fetch(pdfHref);
  if (!response.ok) {
    throw new Error(`Failed to download invoice PDF (${response.status})`);
  }
  return response.blob();
};
